import React from 'react'
import Page from 'components/Page/Page'
import Table from 'components/Display/Table/Table'
import tableHeaderActions from 'constants/tableHeaderActions'
import {useGetEmailBroadcastsQuery} from 'store/Store'

const useNoopMutation = () => [() => Promise.resolve(), {errorDelete: null}]

const SendEmail = () => {
    return (
        <Page>
            <Table
                itemName="email_broadcast"
                paginationType="external"
                allowCreate={false}
                allowEdit={false}
                allowDelete={false}
                allowExpanded
                useGetQuery={useGetEmailBroadcastsQuery}
                useDeleteMutation={useNoopMutation}
                costumeTableHeaderActions={tableHeaderActions.email_broadcasts}
            />
        </Page>
    )
}

export default SendEmail
